import {useTranslation} from 'react-i18next';
import Accordion from 'components/Accordion';
import Checkbox from 'components/Form/Checkbox';
import Stacked from 'components/Layout/Stacked';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import {useBackend} from 'state/backend';
import {EmployeeRightsCreateBackendData} from '../types';

const OtherOptions = () => {
    const {
        appPermissions: {canEditRights},
    } = useBackend<EmployeeRightsCreateBackendData>();
    const {t} = useTranslation('Team.Member.EmployeeRights');

    return (
        <div className="mb-8">
            <Accordion
                aria-label={t('other')}
                className="mb-4"
                header={t('other')}
            >
                <Stacked>
                    <Checkbox
                        helpText={t('timeTrackingHelpText')}
                        label={
                            <span className="flex gap-2 items-center">
                                {t('timeTracking')}
                                <TooltipIcon
                                    href="https://help.makeleaps.jp/ja/articles/3941662-作業時間を管理する"
                                    message={t('whatIsTimeTracking')}
                                    size="base"
                                />
                            </span>
                        }
                        name="time_tracking"
                        readOnly={!canEditRights.allowed}
                    />
                    <Checkbox
                        helpText={t('salesManagementHelpText')}
                        label={t('salesManagement')}
                        name="sales_mgmt_license"
                        readOnly={!canEditRights.allowed}
                    />
                </Stacked>
            </Accordion>
        </div>
    );
};

export default OtherOptions;
